(() => {
	const MAKES_SECTION_ID = 'shopify-section-template--21166203699416__multicolumn_qxf4DV';
	const TOYOTA_SECTION_ID = 'shopify-section-template--21166203699416__multicolumn_pMdF74';

	const makesSection = document.getElementById(MAKES_SECTION_ID);
	const toyotaSection = document.getElementById(TOYOTA_SECTION_ID);
	if (!makesSection || !toyotaSection) return;

	// Grab the inner content we want to move (keeps formatting sane)
	const toyotaInner = toyotaSection.querySelector('.page-width');
	if (!toyotaInner) return;

	// Create a hidden "home" placeholder so we can put the content back on close
	const home = document.createElement('div');
	home.style.display = 'none';
	toyotaSection.parentNode.insertBefore(home, toyotaSection);
	home.appendChild(toyotaInner);

	// Hide the original Toyota section wrapper (we only show the moved inner)
	toyotaSection.classList.add('vehicle-panel-hidden');

	// Find Toyota title link by text, then get the card <li>
	const toyotaTitleLink = [...makesSection.querySelectorAll('a')]
		.find(a => a.textContent.trim().toLowerCase().startsWith('toyota'));
	if (!toyotaTitleLink) return;

	const toyotaLi = toyotaTitleLink.closest('li');
	if (!toyotaLi) return;

    // Add "View models" under the Toyota title
    const infoWrap = toyotaLi.querySelector('.multicolumn-card__info');
    const titleLink = infoWrap?.querySelector('a');

    if (infoWrap && titleLink && !infoWrap.querySelector('.view-models-hint')) {
        const hint = document.createElement('p');
        hint.className = 'view-models-hint';
        hint.textContent = 'View models';
        infoWrap.insertBefore(hint, titleLink.nextSibling);
    }

	let slot = null;
	let open = false;

	const setExpanded = (isOpen) => {
		toyotaLi.querySelectorAll('a').forEach(a => a.setAttribute('aria-expanded', isOpen ? 'true' : 'false'));
	};

	const toggle = () => {
		if (open) {
			home.appendChild(toyotaInner);
			slot?.remove();
			slot = null;
			setExpanded(false);
			open = false;
			return;
		}

		slot?.remove();
		slot = document.createElement('li');
		slot.className = 'vehicle-panel-slot grid__item';

		const list = toyotaLi.parentElement; // <ul class="multicolumn-list ...">
		list.insertBefore(slot, toyotaLi.nextSibling);

		slot.appendChild(toyotaInner);
		setExpanded(true);
		open = true;
	};

	// Make the ENTIRE card clickable (image/title/whitespace)
	toyotaLi.addEventListener('click', (e) => {
		// If they clicked a link, stop navigation
		if (e.target.closest('a')) e.preventDefault();
		toggle();
	});
})();
